import * as yup from 'yup';
import cloneDeep from 'lodash/cloneDeep'
import assign from 'lodash/assign'
import merge from 'lodash/merge'	

import createSingularContainer from '@components/Singular/createSingularContainer'

import { JobModel } from '@modules/job/job.module'
 
import { getEmptyTimesheetLine } from '@modules/timesheet/timesheet.module'


// ['startDate', {
// 	filterDate: (date) => date.getDay() === 1 && date >= (function(d){ d.setDate(d.getDate()-1); return d})(new Date),
// }],

JobModel.startFieldBuffer();

const formConfig = [
	{
		label: "System details",
		fields: JobModel.getFieldProps([
			'status',
			'client',
			'jobType',
			'startDate',
			'notes',
			'timesheet',
			'matchedCandidates',
		]),
	}
];

const fieldPaths = JobModel.endFieldBuffer();
const _cachedSchemas = {};

export default createSingularContainer({
	title: (data) => {
		var title = '';
		if(!data) return title;

		if(data.jobType && data.jobType.label) {
			title += data.jobType.label;
		}

		if(data.client && data.client.clientName) {
			title += title.length ? ', ' : '';
			title += data.client.clientName;
		}

		return title;
	},
	resource: 'job',
	formConfig,
	mapPropsToValues: props => {
		// TODO: handle this more gracefully (same on Client), perhaps create a mergeDefaults function on Model? can automatically populate defaults in fieldArray children present
		var data = cloneDeep(props.data);
		if(data && data.timesheet) {
			// make sure all fields of timesheet have values
			data.timesheet = data.timesheet.map(timesheetLine => assign(getEmptyTimesheetLine(), timesheetLine));
		}

		// merge with defaults
		data = merge(JobModel.getDefaults(), data);

		return data;
	},
	validationSchema: ({ isNew }) => {
		// TODO: add auto caching to validation schema based on repeat args?
		const newState = isNew.toString();
		if(!_cachedSchemas[newState]) {
			_cachedSchemas[newState] = JobModel.getValidationSchema(fieldPaths, { isNew, strictMode: true });
		}
		return _cachedSchemas[newState];
	},
	createdString: 'Posted by',
	supportsDeleting: true,
});




// WEBPACK FOOTER //
// ./src/scenes/Jobs/JobContainer.jsx